import { Container, Reveal, RevealGroup } from '@/components/common'
import type { Advisor } from '@/types/team'
import { board } from '@/constants/advisory-board'

const AdvisorCard = ({ name, role, image }: Advisor) => (
  <article className="group cursor-default">
    <div className="relative overflow-hidden">
      <img
        src={image}
        alt={`Portrait of ${name}`}
        className="aspect-4/5 w-full object-cover object-top grayscale-[55%] transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-ibon-dark/0 transition-colors duration-500 group-hover:bg-ibon-dark/10" />
    </div>
    <div className="mt-5 flex items-start justify-between gap-2">
      <div>
        <h3 className="text-base font-bold leading-snug tracking-tight text-white">{name}</h3>
        <p className="mt-1 text-xs font-semibold uppercase tracking-[0.15em] text-white/60 transition-colors duration-300 group-hover:text-ibon-sky">
          {role}
        </p>
      </div>
      <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-ibon-sky opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
    </div>
  </article>
)

export const AdvisoryBoard = () => {
  return (
    <section className="bg-ibon-dark py-24 lg:py-32">
      <Container>
        <div className="max-w-3xl">
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.02] tracking-[-0.02em] text-white sm:text-5xl lg:text-6xl">
              Guided by experience <span className="text-white/30">and expertise.</span>
            </h2>
          </Reveal>
          <Reveal variant="up" delay={200}>
            <p className="mt-8 text-lg leading-relaxed text-white/60">
              A distinguished group of leaders and experts providing strategic direction and global
              perspective to advance our mission.
            </p>
          </Reveal>
        </div>

        <RevealGroup
          className="mt-16 grid grid-cols-2 gap-x-6 gap-y-14 sm:grid-cols-3 lg:grid-cols-4"
          step={70}
        >
          {board.map((advisor) => (
            <AdvisorCard key={advisor.name} {...advisor} />
          ))}
        </RevealGroup>
      </Container>
    </section>
  )
}
